// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"LocationView_noMargin__1wKro","noMarginText":"LocationView_noMarginText__3b5J2","iconCol":"LocationView_iconCol__3hILa","icon":"LocationView_icon__3JtEx"};